

































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import DefaultTable from '@/views/formList/defaultTable.vue'
import CustomForm from '@/components/custom-form/index.vue'
import HomeSetApi from '@/api/shopMall/pcMallDecorate/homeSet/index'

@Component({
  components: {
    DefaultTable,
    CustomForm
  }
})
export default class PcHomeSet extends Vue {
  editId: any = null
  editModal: boolean = false
  isShowStartTime: boolean = false
  startTime: string = null
  // get isShowStartTime2(): boolean {
  //   return this.isShowStartTime
  // }

  filters = [
    {
      label: '模板名称：',
      type: 'input',
      rule: { required: true, message: '请输入模板名称', trigger: 'blur' },
      key: 'name'
    },
    {
      label: '设为首页',
      type: 'switch',
      key: 'isHome',
      on: {
        'on-change': value => {
          // console.log(value);
          this.isShowStartTime = value
        }
      }
    },
    {
      label: '是否启用',
      type: 'switch',
      key: 'isActive'
    }
    // {
    //   label: '开始时间',
    //   type: 'datetime',
    //   key: 'isShow',
    //   props: {
    //     disabled: this.isShowStartTime
    //   }
    // }
  ]
  handleGetStrartTime(date) {
    console.log(date);
    this.startTime = date
  }
  // 列表页内编辑
  handleEdit(row?) {
    console.log(row);
    // this.editId = (row && row.id) || ''
    // this.editModal = true
    // this.isShowStartTime = row.isHome
    // this.startTime = row.startTime
    // let $formEdit: any = this.$refs.homeSetEdit
    // if (row) {
    //   // 编辑设值
    //   $formEdit.setForm(row)
    // } else {
    //   // 新增清空
    //   $formEdit.reset()
    // }
    this.$router.push({
      name: 'pcHomeSeting',
      query: {
        id: row.id,
        isHome: row.isHome
      }
    })
  }
  // 新增装修页面
  handleAdd() {
    this.$router.push({
      name: 'pcHomeSeting'
    })
  }
  /**
   * 复制页面
   */
  // handleCopy(item) {
  //   console.log('复制模板', item);
  //   HomeSetApi.copyTemplate(item.id).then(res => {
  //     console.log(res)
  //     // this.$router.go(0)
  //   })
  // }
  closeModel() {
    ;(this.$refs.homeSetEdit as any).reset()
    this.editModal = false
  }
  modalOk() {
    let $form: any = this.$refs.homeSetEdit
    $form.submit()
  }
  onSubmit(form, valid) {
    if (valid) {
      let obj: any = {
        startTime: this.startTime
      }
      console.log(obj, this.startTime);
      let { isActive, name, isHome, startTime } = form
      Object.assign(obj, { isActive, name, isHome })
      HomeSetApi.edit(this.editId, obj).then(res => {
        this.$Message.success(this.editId ? '修改成功' : '添加成功')
        this.editModal = false
        ;(this.$refs.tableList as any).getData()
      })
    }
  }
}
